/* landing.js - Interactivity for the OWKAR Product Landing Page */

const initAll = () => {
  const init = (fnName, fn) => {
    try {
      fn();
    } catch (e) {
      console.error(`Error initializing ${fnName}:`, e);
    }
  };
  init('initLandingSpotlight', initLandingSpotlight);
  init('initSpotlightGallery', initSpotlightGallery);
  init('initPdpAccordions', initPdpAccordions);
  init('initProductFeatureAnimation', initProductFeatureAnimation);
  init('initLandingSlider', initLandingSlider);
  init('initHowItWorksCarousel', initHowItWorksCarousel);
  init('initBagsConnectorLines', initBagsConnectorLines);
  init('initFeaturesCarousel', initFeaturesCarousel);
  init('initScrollBackgroundChanger', initScrollBackgroundChanger);
  init('initTestimonialsCarousel', initTestimonialsCarousel);
  init('initVideoModal', initVideoModal);
  init('initShopifyCartSync', initShopifyCartSync);
  init('initBottomShopNow', initBottomShopNow);
  init('initParallaxUnboxing', initParallaxUnboxing);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', initAll);
document.addEventListener('shopify:section:reorder', initAll);

/* --- PDP Spotlight Accordions --- */
function initPdpAccordions() {
  const items = document.querySelectorAll('.pdp-acc-item');
  items.forEach(item => {
    const trigger = item.querySelector('.pdp-acc-trigger');
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const isActive = item.classList.contains('active');
        
        // Close all other accordions
        items.forEach(i => i.classList.remove('active'));
        
        // Toggle current accordion
        if (!isActive) {
          item.classList.add('active');
        }
      });
    }
  });
}

/* --- Spotlight Section Gallery --- */
function initSpotlightGallery() {
  const galleries = document.querySelectorAll('.gallery-container');
  galleries.forEach(gallery => {
    if (gallery.dataset.galleryInitialized === 'true') return;
    gallery.dataset.galleryInitialized = 'true';

    const previewContainer = gallery.querySelector('.gallery-preview');
    const thumbs = gallery.querySelectorAll('.thumb-item');

    if (previewContainer) {
      previewContainer.style.transition = 'opacity 0.15s ease-in-out';
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        if (thumb.classList.contains('active')) return;

        // Update active class
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        // Swap media with a smooth crossfade effect
        const mediaHtml = thumb.dataset.mediaHtml;
        if (previewContainer && mediaHtml) {
          previewContainer.style.opacity = 0;
          setTimeout(() => {
            previewContainer.innerHTML = mediaHtml;
            previewContainer.style.opacity = 1;
          }, 150);
        }
      });
    });
  });
}

/* --- Container Spotlight Purchase Controls (A+ inspired) --- */
function initLandingSpotlight() {
  const sections = document.querySelectorAll('.spotlight-section');
  sections.forEach(section => {
    if (section.dataset.spotlightInitialized === 'true') return;
    section.dataset.spotlightInitialized = 'true';

    const mainQtySelector = section.querySelector('.purchase-controls .quantity-selector');
    const qtyInput = mainQtySelector ? mainQtySelector.querySelector('.qty-input') : null;
    const minusBtn = mainQtySelector ? mainQtySelector.querySelector('.minus-btn') : null;
    const plusBtn = mainQtySelector ? mainQtySelector.querySelector('.plus-btn') : null;

    // Quantity control handlers
    if (minusBtn && plusBtn && qtyInput) {
      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let val = parseInt(qtyInput.value) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
        }
      });

      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });

      qtyInput.addEventListener('change', () => {
        let val = parseInt(qtyInput.value);
        if (isNaN(val) || val < 1) {
          qtyInput.value = 1;
        }
      });
    }

    // Bind upsell cards behavior
    const upsellCards = section.querySelectorAll('.upsell-card');
    
    function updateBundleProgress() {
      const dots = section.querySelectorAll('.bundle-step-dot');
      const lineFill = section.querySelector('.bundle-progress-line-fill');
      
      let activeCount = 0;
      upsellCards.forEach(card => {
        const input = card.querySelector('.upsell-qty-input');
        const qty = input ? parseInt(input.value) || 0 : 0;
        if (qty > 0) {
          activeCount++;
        }
      });
      
      dots.forEach((dot, index) => {
        if (index < activeCount) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      if (lineFill && upsellCards.length > 0) {
        let percent = 0;
        if (activeCount > 0) {
          if (upsellCards.length > 1) {
            percent = ((activeCount - 1) / (upsellCards.length - 1)) * 100;
          } else {
            percent = 100;
          }
        }
        lineFill.style.width = `${percent}%`;
      }
    }

    upsellCards.forEach(card => {
      const addBtn = card.querySelector('.upsell-add-btn');
      const qtySelector = card.querySelector('.upsell-qty-selector');
      const cardMinusBtn = card.querySelector('.minus-btn');
      const cardPlusBtn = card.querySelector('.plus-btn');
      const cardQtyInput = card.querySelector('.upsell-qty-input');
      
      if (addBtn && qtySelector && cardMinusBtn && cardPlusBtn && cardQtyInput) {
        addBtn.addEventListener('click', (e) => {
          e.preventDefault();
          cardQtyInput.value = 1;
          card.classList.add('active');
          addBtn.style.display = 'none';
          qtySelector.style.display = 'flex';
          updateBundleProgress();
        });
        
        cardMinusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(cardQtyInput.value) || 0;
          if (val <= 1) {
            cardQtyInput.value = 0;
            card.classList.remove('active');
            qtySelector.style.display = 'none';
            addBtn.style.display = 'block';
          } else {
            cardQtyInput.value = val - 1;
          }
          updateBundleProgress();
        });
        
        cardPlusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(cardQtyInput.value) || 0;
          cardQtyInput.value = val + 1;
          updateBundleProgress();
        });
      }
    });

    const addToCartBtn = section.querySelector('.spotlight-add-to-cart');
    const buyNowBtn = section.querySelector('.spotlight-buy-now');

    function addSelectedProducts(isBuyNow = false) {
      const targetBtn = isBuyNow ? buyNowBtn : addToCartBtn;
      if (targetBtn && (targetBtn.disabled || targetBtn.getAttribute('aria-disabled') === 'true')) {
        return;
      }

      const qty = parseInt(qtyInput?.value) || 1;
      const mainVariantId = addToCartBtn?.dataset.variantId || buyNowBtn?.dataset.variantId;
      
      if (!mainVariantId) {
        console.warn('Main product variant ID is missing');
        return;
      }

      const payload = {
        items: [{
          id: parseInt(mainVariantId, 10),
          quantity: parseInt(qty, 10)
        }]
      };

      upsellCards.forEach(card => {
        const qInput = card.querySelector('.upsell-qty-input');
        const qVal = qInput ? parseInt(qInput.value) || 0 : 0;
        const variantId = card.dataset.variantId;
        if (variantId && qVal > 0) {
          payload.items.push({
            id: parseInt(variantId, 10),
            quantity: qVal
          });
        }
      });

      // Show loading state
      const originalText = targetBtn ? targetBtn.innerHTML : '';
      if (targetBtn) {
        targetBtn.disabled = true;
        targetBtn.innerHTML = '<span>Adding...</span>';
      }

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionsToRender = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sectionsToRender.push(item.dataset.sectionId);
        }
      });
      if (sectionsToRender.length > 0) {
        payload.sections = sectionsToRender.join(',');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add items to cart');
          });
        }
        return res.json();
      })
      .then(data => {
        if (targetBtn) {
          targetBtn.disabled = false;
          targetBtn.innerHTML = originalText;
        }
    
        if (isBuyNow) {
          window.location.href = '/checkout';
        } else {
          // Dispatch theme events
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'custom-landing-add-to-cart',
              data: {
                sections: data.sections || {}
              }
            }
          }));
    
          document.dispatchEvent(new CustomEvent('cart:add', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'custom-landing-add-to-cart',
              data: {
                sections: data.sections || {}
              }
            }
          }));
    
          const nativeDrawer = document.querySelector('cart-drawer-component');
          if (nativeDrawer && typeof nativeDrawer.open === 'function') {
            nativeDrawer.open();
          } else {
            window.location.reload();
          }
        }
      })
      .catch(err => {
        console.error('Cart operation failed:', err);
        alert('Error adding items: ' + err.message);
        if (targetBtn) {
          targetBtn.disabled = false;
          targetBtn.innerHTML = originalText;
        }
      });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (addToCartBtn.disabled || addToCartBtn.getAttribute('aria-disabled') === 'true') return;
        addSelectedProducts(false);
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (buyNowBtn.disabled || buyNowBtn.getAttribute('aria-disabled') === 'true') return;
        addSelectedProducts(true);
      });
    }
  });
}

// Re-initialize gallery and spotlight features on section load in theme editor
document.addEventListener('shopify:section:load', () => {
  initSpotlightGallery();
  initLandingSpotlight();
  initBottomShopNow();
});

/* --- Bottom CTA Shop Now Button checkout --- */
function initBottomShopNow() {
  const bottomShopNow = document.getElementById('bottom-shop-now');
  if (bottomShopNow) {
    if (bottomShopNow.dataset.shopNowInitialized === 'true') return;
    bottomShopNow.dataset.shopNowInitialized = 'true';

    bottomShopNow.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = bottomShopNow.dataset.variantId;
      if (!variantId) return;

      const originalText = bottomShopNow.innerHTML;
      bottomShopNow.disabled = true;
      bottomShopNow.innerHTML = '<span>Adding...</span>';

      const payload = {
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => {
            throw new Error(err.description || err.message || 'Checkout failed');
          });
        }
        return res.json();
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(err => {
        console.error('Checkout redirect failed:', err);
        bottomShopNow.disabled = false;
        bottomShopNow.innerHTML = originalText;
        window.location.href = `/cart/add?id=${variantId}&quantity=1`;
      });
    });
  }
}


/* --- Product Feature Section Reveal Animation --- */
function initProductFeatureAnimation() {
  const section = document.querySelector('.landing-info-section');
  if (!section) return;

  const circle = section.querySelector('.product-circle-bg');
  const sealer = section.querySelector('.product-device-img');
  const bag = section.querySelector('.product-bag-img');
  const containerImg = section.querySelector('.product-container-img');
  const bagCaption = section.querySelector('.bag-caption');
  const containerCaption = section.querySelector('.container-caption');
  const cards = section.querySelectorAll('.feature-pill-card');

  // Staggered translate offsets (matching CSS transitions exactly to avoid visual jumps)
  const offsets = [25, -20, 35, -5, -15, 30, -25, 10]; // Left 1-4, Right 1-4

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        section.classList.add('animation-active');
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll);
        handleScroll(); // Trigger initial position calculation
      }
    });
  }, observerOptions);

  observer.observe(section);

  function handleScroll() {
    if (window.innerWidth <= 991) {
      // Clean up styles on mobile width viewports to preserve standard responsive layout
      section.classList.remove('scroll-animating');
      if (circle) {
        circle.style.opacity = '';
        circle.style.transform = '';
      }
      if (sealer) {
        sealer.style.opacity = '';
        sealer.style.transform = '';
      }
      if (bag) {
        bag.style.opacity = '';
        bag.style.transform = '';
      }
      if (containerImg) {
        containerImg.style.opacity = '';
        containerImg.style.transform = '';
      }
      if (bagCaption) {
        bagCaption.style.opacity = '';
        bagCaption.style.transform = '';
      }
      if (containerCaption) {
        containerCaption.style.opacity = '';
        containerCaption.style.transform = '';
      }
      cards.forEach(card => {
        card.style.opacity = '';
        card.style.transform = '';
      });
      return;
    }

    const rect = section.getBoundingClientRect();
    const sectionHeight = rect.height;
    const viewportHeight = window.innerHeight;

    // Calculate absolute scroll limits for pinning track
    const scrollStart = window.scrollY + rect.top;
    const scrollEnd = scrollStart + sectionHeight - viewportHeight;
    const currentScroll = window.scrollY;

    let progress = 0;
    if (currentScroll > scrollStart) {
      progress = (currentScroll - scrollStart) / (scrollEnd - scrollStart);
    }
    progress = Math.max(0, Math.min(1, progress));

    // Enable class to bypass transitions while scrolling
    if (currentScroll >= scrollStart && currentScroll <= scrollEnd) {
      section.classList.add('scroll-animating');
    } else {
      section.classList.remove('scroll-animating');
    }

    // --- ANIMATION TIMELINE SCHEDULER ---

    // 1. Circle & Feature Pills Fade Out (0.0 -> 0.25 scroll progress)
    let fadeProgress = progress / 0.25;
    fadeProgress = Math.max(0, Math.min(1, fadeProgress));
    // Apply Quad Ease Out for smooth fading deceleration
    const easedFade = fadeProgress * (2 - fadeProgress);
    const opacityVal = 1 - easedFade;

    if (circle) {
      circle.style.opacity = opacityVal;
      circle.style.transform = `scale(${1 - easedFade * 0.15})`;
    }

    cards.forEach((card, index) => {
      card.style.opacity = opacityVal;
      const baseOffset = offsets[index] || 0;
      const driftY = easedFade * -20; // Float slightly upward as they fade
      card.style.transform = `translateX(${baseOffset}px) translateY(${driftY}px) scale(${1 - easedFade * 0.05})`;
    });

    // 2. Sealer moves up & scales down slightly (0.0 -> 0.30 scroll progress) & centers back and scales up more at the end (0.93 -> 1.0 progress)
    let sealerProgress = progress / 0.30;
    sealerProgress = Math.max(0, Math.min(1, sealerProgress));
    const easedSealer = sealerProgress * (2 - sealerProgress);

    let sealerResetProgress = 0;
    if (progress > 0.93) {
      sealerResetProgress = (progress - 0.93) / 0.07;
    }
    sealerResetProgress = Math.max(0, Math.min(1, sealerResetProgress));
    const easedSealerReset = sealerResetProgress * (2 - sealerResetProgress);

    if (sealer) {
      const sealerTranslateY = -90 * easedSealer * (1 - easedSealerReset); // Shifts sealer back to center (0px)
      const sealerScale = (1 - (easedSealer * 0.15)) + (0.85 * easedSealerReset); // Scales sealer back up to 1.70 for prominent hero focus
      sealer.style.transform = `translateY(${sealerTranslateY}px) scale(${sealerScale})`;
      sealer.style.opacity = '1';
    }

    // 3. Bag Timeline: Slides In (0.15 -> 0.45) & Shifts to Left Side resting position (0.48 -> 0.65)
    let bagOpacity = 0;
    let bagTransform = 'translateX(-120vw) translateY(73px) scale(1)';

    if (progress >= 0.15 && progress < 0.48) {
      // Slide in from left viewport edge
      let bagIn = (progress - 0.15) / 0.30;
      bagIn = Math.max(0, Math.min(1, bagIn));
      // Quad Ease In-Out for smooth entrance accelerate/decelerate
      const easedBagIn = bagIn < 0.5 ? 2 * bagIn * bagIn : 1 - Math.pow(-2 * bagIn + 2, 2) / 2;
      
      bagOpacity = easedBagIn;
      const bagXOffset = -130 * easedBagIn;
      const bagTranslateX = -120 * (1 - easedBagIn);
      bagTransform = `translateX(calc(${bagTranslateX}vw + ${bagXOffset}px)) translateY(73px) scale(1)`;
    } else if (progress >= 0.48) {
      // Shift to the left of the sealer device and scale down to rest, then scale back up at the end (progress 0.93 -> 1.0)
      let bagShift = (progress - 0.48) / 0.17;
      bagShift = Math.max(0, Math.min(1, bagShift));
      const easedBagShift = bagShift < 0.5 ? 2 * bagShift * bagShift : 1 - Math.pow(-2 * bagShift + 2, 2) / 2;
      
      bagOpacity = 1;
      const bagX = -130 - (230 * easedBagShift); // Shifts from -130px to -360px
      const bagY = 73 + (60 * easedBagShift); // Shifts from 73px to 133px
      const bagScale = 1 - (0.05 * easedBagShift); // Scales from 1 to 0.95
      const bagFinalScale = bagScale + (0.35 * easedSealerReset); // Scales up from 0.95 to 1.30 at the end
      bagTransform = `translateX(${bagX}px) translateY(${bagY}px) scale(${bagFinalScale})`;
    }

    if (bag) {
      bag.style.opacity = bagOpacity;
      bag.style.transform = bagTransform;
    }

    // 4. Container Timeline: Slides In (0.60 -> 0.80) & Shifts to Right Side resting position (0.82 -> 0.95)
    let containerOpacity = 0;
    let containerTransform = 'translateX(120vw) translateY(134px) scale(1)';

    if (progress >= 0.60 && progress < 0.82) {
      // Slide in from right viewport edge (+120vw) to center alignment under sealer nozzle
      let containerIn = (progress - 0.60) / 0.20;
      containerIn = Math.max(0, Math.min(1, containerIn));
      // Quad Ease In-Out
      const easedContainerIn = containerIn < 0.5 ? 2 * containerIn * containerIn : 1 - Math.pow(-2 * containerIn + 2, 2) / 2;
      
      containerOpacity = easedContainerIn;
      const containerTranslateX = 120 * (1 - easedContainerIn);
      containerTransform = `translateX(${containerTranslateX}vw) translateY(134px) scale(1)`;
    } else if (progress >= 0.82) {
      // Shift to the right of the sealer device and scale down to rest, then scale back up at the end (progress 0.93 -> 1.0)
      let containerShift = (progress - 0.82) / 0.13;
      containerShift = Math.max(0, Math.min(1, containerShift));
      const easedContainerShift = containerShift < 0.5 ? 2 * containerShift * containerShift : 1 - Math.pow(-2 * containerShift + 2, 2) / 2;
      
      containerOpacity = 1;
      const containerX = 360 * easedContainerShift; // Shifts from 0 to 360px
      const containerScale = 1.0; // Stays at full size
      const containerFinalScale = containerScale + (0.35 * easedSealerReset); // Scales up from 1.0 to 1.35 at the end
      containerTransform = `translateX(${containerX}px) translateY(134px) scale(${containerFinalScale})`;
    }

    if (containerImg) {
      containerImg.style.opacity = containerOpacity;
      containerImg.style.transform = containerTransform;
    }

    // 5. Captions Fade In & Slide Up (0.93 -> 1.0 progress)
    let captionOpacity = easedSealerReset;
    let captionSlideY = 15 * (1 - easedSealerReset); // Translate downwards by 15px when hidden, sliding up to 0px

    if (bagCaption) {
      bagCaption.style.opacity = captionOpacity;
      bagCaption.style.transform = `translateY(${captionSlideY}px)`;
    }

    if (containerCaption) {
      containerCaption.style.opacity = captionOpacity;
      containerCaption.style.transform = `translateY(${captionSlideY}px)`;
    }
  }
}

/* --- Before / After Interactive Slider --- */
function initLandingSlider() {
  const containers = document.querySelectorAll('.comparison-slider');
  if (!containers.length) return;

  containers.forEach(container => {
    const sliderInput = container.querySelector('#comp-slider-input');
    const afterLayer = container.querySelector('#comp-slider-after-layer');
    const handle = container.querySelector('#comp-slider-handle');

    if (!sliderInput || !afterLayer || !handle) return;

    function updateSlider() {
      const value = parseInt(sliderInput.value);
      afterLayer.style.clipPath = `polygon(${value}% 0, 100% 0, 100% 100%, ${value}% 100%)`;
      handle.style.left = `${value}%`;

      const beforeContent = container.querySelector('.before-content');
      const afterContent = container.querySelector('.after-content');

      if (beforeContent && afterContent) {
        if (value <= 1) {
          beforeContent.style.display = 'none';
          beforeContent.style.opacity = '0';
          beforeContent.style.visibility = 'hidden';
        } else {
          beforeContent.style.display = 'flex';
          beforeContent.style.opacity = '1';
          beforeContent.style.visibility = 'visible';
        }

        if (value >= 99) {
          afterContent.style.display = 'none';
          afterContent.style.opacity = '0';
          afterContent.style.visibility = 'hidden';
        } else {
          afterContent.style.display = 'flex';
          afterContent.style.opacity = '1';
          afterContent.style.visibility = 'visible';
        }
      }
    }

    if (container.dataset.sliderInitialized !== 'true') {
      container.dataset.sliderInitialized = 'true';
      sliderInput.addEventListener('input', updateSlider);
      sliderInput.addEventListener('change', updateSlider);
    }

    updateSlider();
  });
}

/* --- How It Works Carousel Interactivity --- */
function initHowItWorksCarousel() {
  const section = document.querySelector('.how-it-works-carousel-section');
  if (!section) return;

  const slides = section.querySelectorAll('.carousel-slide');
  const tabBtns = section.querySelectorAll('.step-tab-btn');
  const dots = section.querySelectorAll('.carousel-dot');
  const prevBtn = section.querySelector('.prev-btn');
  const nextBtn = section.querySelector('.next-btn');
  const sliderWrapper = section.querySelector('.carousel-card-slider-wrapper');

  let currentIndex = 0;
  let autoplayTimer = null;
  const autoplayInterval = 3000; // Snappy 3.0 seconds transition speed

  function showSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentIndex = index;

    // Show/hide slides
    slides.forEach((slide, i) => {
      if (i === currentIndex) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });

    // Update segmented pills
    tabBtns.forEach((btn, i) => {
      if (i <= currentIndex) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Update progress bar line fill
    const progressFill = section.querySelector('.step-progress-fill');
    if (progressFill && tabBtns.length > 1) {
      const percent = (currentIndex / (tabBtns.length - 1)) * 100;
      progressFill.style.width = `${percent}%`;
    }

    // Update carousel dots
    dots.forEach((dot, i) => {
      if (i === currentIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  function nextSlide() {
    showSlide(currentIndex + 1);
  }

  function prevSlide() {
    showSlide(currentIndex - 1);
  }

  function startAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = setInterval(nextSlide, autoplayInterval);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  // Bind tab buttons click
  tabBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const stepIndex = parseInt(btn.getAttribute('data-step'));
      showSlide(stepIndex);
      startAutoplay();
    });
  });

  // Bind dot navigation click
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const stepIndex = parseInt(dot.getAttribute('data-step'));
      showSlide(stepIndex);
      startAutoplay();
    });
  });

  // Bind arrow keys/clicks
  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      prevSlide();
      startAutoplay();
    });
    nextBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      nextSlide();
      startAutoplay();
    });
  }

  // Stop autoplay on hover
  if (sliderWrapper) {
    sliderWrapper.addEventListener('mouseenter', stopAutoplay);
    sliderWrapper.addEventListener('mouseleave', startAutoplay);
  }

  // Run on start
  showSlide(0);
  startAutoplay();
}

/* --- Reusable Bags Section SVG Connector Lines --- */
function initBagsConnectorLines() {
  const svg = document.getElementById('bags-connector-svg');
  if (!svg) return;

  const circleFrame = document.querySelector('.bags-circular-frame');
  const icons = document.querySelectorAll('.bags-callout-icon');
  
  if (!circleFrame || icons.length === 0) return;

  function updateLines() {
    svg.innerHTML = '';

    // Hide lines on mobile/tablets since elements stack vertically
    if (window.innerWidth <= 991) {
      return;
    }

    const svgRect = svg.getBoundingClientRect();
    const circleRect = circleFrame.getBoundingClientRect();

    const circleCenterX = circleRect.left - svgRect.left + (circleRect.width / 2);
    const circleCenterY = circleRect.top - svgRect.top + (circleRect.height / 2);
    const radius = circleRect.width / 2;

    icons.forEach((icon, index) => {
      const card = icon.closest('.bags-callout-card');
      if (!card) return;

      const cardRect = card.getBoundingClientRect();
      const isLeftCol = index < 3;
      
      // Calculate Y coordinate of the line (centered vertically on the card)
      const lineY = cardRect.top - svgRect.top + (cardRect.height / 2);
      
      // Vertical distance from the circle center
      const dy = lineY - circleCenterY;
      
      // Horizontal offset from the circle center along the circumference
      const absDy = Math.min(Math.abs(dy), radius - 2);
      const dx = Math.sqrt(radius * radius - absDy * absDy);
      
      // Intersection coordinates on the circular frame's ring boundary
      const circleX = isLeftCol ? (circleCenterX - dx) : (circleCenterX + dx);
      const circleY = lineY;

      // Start coordinate on the card edge facing the circle
      const cardX = isLeftCol ? (cardRect.right - svgRect.left) : (cardRect.left - svgRect.left);

      // Create dotted line element
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', cardX);
      line.setAttribute('y1', lineY);
      line.setAttribute('x2', circleX);
      line.setAttribute('y2', circleY);
      line.setAttribute('stroke', '#6FA424'); // Green accent color (#6FA424)
      line.setAttribute('stroke-width', '2');
      line.setAttribute('stroke-dasharray', '2,4'); // 2px dotted style
      svg.appendChild(line);

      // Create small solid dot at the circle intersection point
      const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      dot.setAttribute('cx', circleX);
      dot.setAttribute('cy', circleY);
      dot.setAttribute('r', '4'); // 4px radius solid dot
      dot.setAttribute('fill', '#6FA424');
      svg.appendChild(dot);
    });
  }

  // Draw initially and bind listeners
  updateLines();
  window.addEventListener('resize', updateLines);
  
  // Also hook into scroll or delay to accommodate lazy layouts/images fully loading
  window.addEventListener('load', updateLines);
  setTimeout(updateLines, 500);
}

/* --- Full Width Infinite Features Carousel --- */
function initFeaturesCarousel() {
  const section = document.querySelector('.features-carousel-section');
  if (!section) return;

  const track = section.querySelector('.carousel-track');
  const prevBtn = section.querySelector('.prev-arrow');
  const nextBtn = section.querySelector('.next-arrow');
  if (!track) return;

  const originalCards = Array.from(track.children);
  const cardCount = originalCards.length;
  if (cardCount === 0) return;

  // Clone cards to achieve infinite looping
  originalCards.forEach(card => {
    const clone = card.cloneNode(true);
    track.appendChild(clone);
  });

  originalCards.slice().reverse().forEach(card => {
    const clone = card.cloneNode(true);
    track.insertBefore(clone, track.firstChild);
  });

  let currentIndex = cardCount; // start at the first original card
  let isTransitioning = false;
  let slideWidth = 0;
  let currentTranslate = 0;

  function updateDimensions() {
    const firstCard = track.children[0];
    if (!firstCard) return;
    const cardWidth = firstCard.getBoundingClientRect().width;
    const gap = parseInt(window.getComputedStyle(track).gap) || 24;
    slideWidth = cardWidth + gap;
    
    // Position the track without transition
    track.style.transition = 'none';
    currentTranslate = -currentIndex * slideWidth;
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  // Initial dimension setup
  updateDimensions();
  window.addEventListener('load', updateDimensions);
  window.addEventListener('resize', updateDimensions);

  function moveCarousel(direction) {
    if (isTransitioning) return;
    isTransitioning = true;

    track.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
    if (direction === 'next') {
      currentIndex++;
    } else {
      currentIndex--;
    }

    currentTranslate = -currentIndex * slideWidth;
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  // Buttons Event Listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      moveCarousel('prev');
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      moveCarousel('next');
    });
  }

  // Seamless jump at transition end
  track.addEventListener('transitionend', () => {
    isTransitioning = false;
    
    if (currentIndex >= cardCount * 2) {
      track.style.transition = 'none';
      currentIndex = cardCount;
      currentTranslate = -currentIndex * slideWidth;
      track.style.transform = `translateX(${currentTranslate}px)`;
    } else if (currentIndex < cardCount) {
      track.style.transition = 'none';
      currentIndex = cardCount * 2 - 1;
      currentTranslate = -currentIndex * slideWidth;
      track.style.transform = `translateX(${currentTranslate}px)`;
    }
  });

  // Drag and Swipe Interactions (Mouse and Touch)
  let isDragging = false;
  let startX = 0;
  let prevTranslate = 0;

  function getPositionX(e) {
    return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
  }

  function dragStart(e) {
    if (isTransitioning) return;
    isDragging = true;
    startX = getPositionX(e);
    prevTranslate = currentTranslate;
    track.classList.add('dragging');
  }

  function dragMove(e) {
    if (!isDragging) return;
    if (e.type === 'touchmove') {
      e.preventDefault();
    }
    const currentX = getPositionX(e);
    const diff = currentX - startX;
    currentTranslate = prevTranslate + diff;
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('dragging');

    const movedBy = currentTranslate - prevTranslate;
    const threshold = 70;

    if (movedBy < -threshold) {
      moveCarousel('next');
    } else if (movedBy > threshold) {
      moveCarousel('prev');
    } else {
      isTransitioning = true;
      track.style.transition = 'transform 0.4s cubic-bezier(0.25, 1, 0.5, 1)';
      currentTranslate = -currentIndex * slideWidth;
      track.style.transform = `translateX(${currentTranslate}px)`;
    }
  }

  // Mouse Listeners
  track.addEventListener('mousedown', dragStart);
  window.addEventListener('mousemove', dragMove);
  window.addEventListener('mouseup', dragEnd);

  // Touch Listeners
  track.addEventListener('touchstart', dragStart, { passive: true });
  track.addEventListener('touchmove', dragMove, { passive: false });
  track.addEventListener('touchend', dragEnd);
}

/* --- Scroll-Driven Background Color Changer --- */
function initScrollBackgroundChanger() {
  const wrapper = document.querySelector('.landing-redesign-wrapper');
  if (!wrapper) return;

  const colorTriggers = [
    { selector: '#main-pdp-section', color: [26, 40, 2] }, // --dark-bg (#1A2802)
    // { selector: '.features-carousel-section', color: [238, 248, 232] }, 
    { selector: '.landing-info-section', color: [7, 11, 1] }, // --darker-bg (#0F1801)
    { selector: '.landing-comparison-visual-section', color: [7, 11, 1] },
    { selector: '.how-it-works-carousel-section', color: [7, 11, 1] },
    { selector: '.benefits-box-section', color: [46, 67, 3] }, // --primary (#2E4303)
    { selector: '.landing-bags-diagram-section', color: [7, 11, 1] },
    { selector: '.landing-comparison-table-section', color: [238, 248, 232] }, // --third (#EEF8E8)
    { selector: '.testimonials-section', color: [238, 248, 232] }, // --third (#EEF8E8)
    { selector: '.landing-bottom-cta-section', color: [7, 11, 1] } // --darker-bg (#0F1801)
  ];

  function updateBackground() {
    const scrollTop = window.scrollY || window.pageYOffset;
    const viewportHeight = window.innerHeight;
    const scrollCenter = scrollTop + viewportHeight / 2;

    const activeTriggers = [];
    colorTriggers.forEach(trigger => {
      const el = document.querySelector(trigger.selector);
      if (el) {
        const rect = el.getBoundingClientRect();
        const top = scrollTop + rect.top;
        const height = el.offsetHeight;
        const midpoint = top + height / 2;
        activeTriggers.push({
          midpoint: midpoint,
          color: trigger.color,
          top: top,
          bottom: top + height
        });
      }
    });

    if (activeTriggers.length === 0) return;

    activeTriggers.sort((a, b) => a.midpoint - b.midpoint);

    let finalColor = activeTriggers[0].color;

    if (scrollCenter <= activeTriggers[0].midpoint) {
      finalColor = activeTriggers[0].color;
    } else if (scrollCenter >= activeTriggers[activeTriggers.length - 1].midpoint) {
      finalColor = activeTriggers[activeTriggers.length - 1].color;
    } else {
      for (let i = 0; i < activeTriggers.length - 1; i++) {
        const a = activeTriggers[i];
        const b = activeTriggers[i + 1];
        if (scrollCenter >= a.midpoint && scrollCenter <= b.midpoint) {
          const ratio = (scrollCenter - a.midpoint) / (b.midpoint - a.midpoint);
          const r = Math.round(a.color[0] + (b.color[0] - a.color[0]) * ratio);
          const g = Math.round(a.color[1] + (b.color[1] - a.color[1]) * ratio);
          const bVal = Math.round(a.color[2] + (b.color[2] - a.color[2]) * ratio);
          finalColor = [r, g, bVal];
          break;
        }
      }
    }

    // Apply color to the wrapper background with smooth radial lighting accent
    wrapper.style.background = `radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.15) 0%, transparent 80%), rgb(${finalColor[0]}, ${finalColor[1]}, ${finalColor[2]})`;
  }

  window.addEventListener('scroll', updateBackground, { passive: true });
  window.addEventListener('resize', updateBackground);
  updateBackground();
}

/* --- Testimonials Carousel Slider with Infinite Loop --- */
function initTestimonialsCarousel() {
  const wrapper = document.querySelector('.testimonials-carousel-wrapper');
  const track = document.querySelector('.testimonials-track-v2');
  const prevBtn = document.querySelector('.prev-v2');
  const nextBtn = document.querySelector('.next-v2');
  let cards = document.querySelectorAll('.testimonial-card-v2');

  if (!wrapper || !track || !prevBtn || !nextBtn || cards.length === 0) return;

  const originalCount = cards.length;
  const cloneCount = 4;

  const originalCardsArray = Array.from(cards);
  
  const endClones = originalCardsArray.slice(0, cloneCount).map(card => card.cloneNode(true));
  const startClones = originalCardsArray.slice(-cloneCount).map(card => card.cloneNode(true));

  track.innerHTML = '';
  startClones.forEach(c => track.appendChild(c));
  originalCardsArray.forEach(c => track.appendChild(c));
  endClones.forEach(c => track.appendChild(c));

  cards = document.querySelectorAll('.testimonial-card-v2');

  let currentIndex = cloneCount;
  let isTransitioning = false;

  function getSlideAmount() {
    if (cards.length === 0) return 0;
    const cardWidth = cards[0].offsetWidth;
    const computedStyle = window.getComputedStyle(track);
    const gap = parseInt(computedStyle.gap) || 28;
    return cardWidth + gap;
  }

  function updateCarousel(instant = false) {
    const slideAmount = getSlideAmount();
    const offset = -currentIndex * slideAmount;
    
    if (instant) {
      track.style.transition = 'none';
    } else {
      track.style.transition = 'transform 0.45s cubic-bezier(0.16, 1, 0.3, 1)';
    }

    track.style.transform = `translateX(${offset}px)`;
  }

  track.addEventListener('transitionend', () => {
    isTransitioning = false;
    
    if (currentIndex >= originalCount + cloneCount) {
      currentIndex = cloneCount;
      updateCarousel(true);
    }
    else if (currentIndex < cloneCount) {
      currentIndex = originalCount + cloneCount - 1;
      updateCarousel(true);
    }
  });

  nextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex++;
    updateCarousel();
  });

  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex--;
    updateCarousel();
  });

  window.addEventListener('resize', () => {
    updateCarousel(true);
  });

  setTimeout(() => {
    updateCarousel(true);
  }, 100);
}

/* --- Video Review Modal Popup (using Event Delegation) --- */
function initVideoModal() {
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.testimonial-card-v2');
    if (!card) return;

    const videoUrl = card.getAttribute('data-video-url');
    if (!videoUrl) return;

    e.preventDefault();
    openModal(videoUrl);
  });

  function openModal(url) {
    const modal = document.createElement('div');
    modal.className = 'video-popup-modal';
    modal.innerHTML = `
      <div class="modal-backdrop"></div>
      <div class="modal-video-container">
        <button class="modal-close-btn" aria-label="Close video">✕</button>
        <video src="${url}" controls autoplay class="modal-video-player" playsinline></video>
      </div>
    `;

    const video = modal.querySelector('.modal-video-player');
    const container = modal.querySelector('.modal-video-container');
    if (video && container) {
      video.addEventListener('loadedmetadata', () => {
        if (video.videoHeight > video.videoWidth) {
          container.classList.add('portrait');
        }
      });
    }

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    const backdrop = modal.querySelector('.modal-backdrop');
    const closeBtn = modal.querySelector('.modal-close-btn');
    
    const closeModal = () => {
      modal.classList.add('closing');
      setTimeout(() => {
        modal.remove();
        document.body.style.overflow = '';
      }, 250);
    };

    backdrop.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', handleKeyDown);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
  }
}

/* --- Shopify Cart Sync and Checkout AJAX Actions --- */
function initShopifyCartSync() {
  const cartBubble = document.getElementById('cart-bubble');

  function updateCartBubble() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (cartBubble) {
          cartBubble.textContent = cart.item_count;
          cartBubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(err => console.error('Error fetching cart state:', err));
  }

  updateCartBubble();

  document.addEventListener('cart:update', () => {
    updateCartBubble();
  });

  const cartIcon = document.getElementById('cart-icon-btn');
  if (cartIcon) {
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      const nativeDrawer = document.querySelector('cart-drawer-component');
      if (nativeDrawer && typeof nativeDrawer.open === 'function') {
        nativeDrawer.open();
      }
    });
  }
}

/* --- Pinned Scroll Parallax Unboxing & Side Reveal Animation --- */
function initParallaxUnboxing() {
  const section = document.querySelector('.parallax-section');
  const sealer = document.getElementById('parallax-sealer-img');
  const box = document.getElementById('parallax-box-img');
  const cap = document.getElementById('parallax-box-cap-img');
  const leftEl = document.getElementById('side-left-el');
  const rightEl = document.getElementById('side-right-el');
  const leftCap = document.getElementById('side-left-cap');
  const rightCap = document.getElementById('side-right-cap');
  const arrowImg = document.getElementById('unboxing-arrow-img');
  const arrowCap = document.getElementById('unboxing-arrow-caption');
  const arrowImgRight = document.getElementById('unboxing-arrow-img-right');
  const arrowCapRight = document.getElementById('unboxing-arrow-caption-right');
 
  if (!section || !sealer || !box || !cap || !leftEl || !rightEl || !leftCap || !rightCap || !arrowImg || !arrowCap || !arrowImgRight || !arrowCapRight) return;

  function handleScroll() {
    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const totalStickyScroll = rect.height - viewportHeight;

    if (totalStickyScroll <= 0) return;

    if (rect.top <= 0 && rect.bottom >= viewportHeight) {
      const progress = Math.abs(rect.top) / totalStickyScroll;
      
      let sealerY, sealerScale, boxY, boxOpacity;
      let leftOpacity = 0, leftTranslateX = -120;
      let rightOpacity = 0, rightTranslateX = 120;
      let capOpacity = 0;

      if (progress <= 0.40) {
        const p1 = progress / 0.40;
        const startY = 220;
        const endY = -90;
        sealerY = startY - (p1 * (startY - endY));
        sealerScale = 1.0;
        boxY = 0;
        boxOpacity = 1.0;
      } 
      else if (progress <= 0.70) {
        const p2 = (progress - 0.40) / 0.30;
        sealerY = -90;
        sealerScale = 1.0 + (p2 * 0.35);
        boxY = p2 * 350;
        boxOpacity = 1.0 - p2;
      } 
      else {
        const p3 = (progress - 0.70) / 0.30;
        sealerY = -90;
        sealerScale = 1.35;
        boxY = 350;
        boxOpacity = 0.0;
        leftOpacity = p3;
        leftTranslateX = -120 + (p3 * 120);
        rightOpacity = p3;
        rightTranslateX = 120 - (p3 * 120);

        if (progress > 0.85) {
          capOpacity = (progress - 0.85) / 0.15;
        }
      }

      sealer.style.transform = `translateY(${sealerY}px) scale(${sealerScale})`;
      box.style.transform = `translateY(${boxY}px)`;
      box.style.opacity = boxOpacity;
      cap.style.transform = `translateY(${boxY}px)`;
      cap.style.opacity = boxOpacity;

      leftEl.style.opacity = leftOpacity;
      leftEl.style.transform = `translateX(${leftTranslateX}px)`;
      leftCap.style.opacity = capOpacity;
      arrowImg.style.opacity = leftOpacity;
      arrowImg.style.transform = `translateX(${leftTranslateX}px) rotate(45deg)`;
      arrowCap.style.opacity = leftOpacity;
      arrowCap.style.transform = `translateX(${leftTranslateX}px)`;
 
      rightEl.style.opacity = rightOpacity;
      rightEl.style.transform = `translateX(${rightTranslateX}px)`;
      rightCap.style.opacity = capOpacity;
      arrowImgRight.style.opacity = rightOpacity;
      arrowImgRight.style.transform = `translateX(${rightTranslateX}px) rotate(-45deg)`;
      arrowCapRight.style.opacity = rightOpacity;
      arrowCapRight.style.transform = `translateX(${rightTranslateX}px)`;
    } 
    else if (rect.top > 0) {
      sealer.style.transform = 'translateY(220px) scale(1)';
      box.style.transform = 'translateY(0)';
      box.style.opacity = '1';
      cap.style.transform = 'translateY(0)';
      cap.style.opacity = '1';

      leftEl.style.opacity = '0';
      leftEl.style.transform = 'translateX(-120px)';
      leftCap.style.opacity = '0';
      arrowImg.style.opacity = '0';
      arrowImg.style.transform = 'translateX(-120px) rotate(45deg)';
      arrowCap.style.opacity = '0';
      arrowCap.style.transform = 'translateX(-120px)';

      rightEl.style.opacity = '0';
      rightEl.style.transform = 'translateX(120px)';
      rightCap.style.opacity = '0';
      arrowImgRight.style.opacity = '0';
      arrowImgRight.style.transform = 'translateX(120px) rotate(-45deg)';
      arrowCapRight.style.opacity = '0';
      arrowCapRight.style.transform = 'translateX(120px)';
    } 
    else if (rect.bottom < viewportHeight) {
      sealer.style.transform = 'translateY(-90px) scale(1.35)';
      box.style.transform = 'translateY(350px)';
      box.style.opacity = '0';
      cap.style.transform = 'translateY(350px)';
      cap.style.opacity = '0';

      leftEl.style.opacity = '1';
      leftEl.style.transform = 'translateX(0)';
      leftCap.style.opacity = '1';
      arrowImg.style.opacity = '1';
      arrowImg.style.transform = 'translateX(0) rotate(45deg)';
      arrowCap.style.opacity = '1';
      arrowCap.style.transform = 'translateX(0)';

      rightEl.style.opacity = '1';
      rightEl.style.transform = 'translateX(0)';
      rightCap.style.opacity = '1';
      arrowImgRight.style.opacity = '1';
      arrowImgRight.style.transform = 'translateX(0) rotate(-45deg)';
      arrowCapRight.style.opacity = '1';
      arrowCapRight.style.transform = 'translateX(0)';
    }
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
  setTimeout(handleScroll, 100);
}


